import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { useStyleStore } from "@vcl";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class BorderColor extends BaseOption {
  static userInterfaceComponent = {
    label: "Border Color",
    component: inspectorTools.COLOR_PICKER,
    props: {
      colorContext: "Borders",
    },
    canSetOtherStates: [BaseOption.$states.HOVER],
  };

  static defaultValue = {
    value: "none",
    source: "theme.border",
  };

  static convertConfigValueToCompiledValue(configValue, themeId, themeMode = "inherit") {
    const styleStore = useStyleStore();
    let palette = styleStore.themePalettes[themeId];
    if (configValue.source.includes("semantic")) {
      palette = styleStore.getSemanticPaletteFromMode(themeId, themeMode);
    }
    return BaseOption.getColorValue(configValue, styleStore.themes[themeId], palette, themeId, themeMode);
  }

  static convertValueToStringForTransactionLog(compiledValue) {
    return compiledValue.value;
  }
}
